import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8f9fa',
      color: '#343a40',
      textAlign: 'center',
      padding: '20px'
    }}>
      <h1 style={{ fontSize: '6rem', marginBottom: '20px' }}>404</h1>
      <h2 style={{ marginBottom: '10px' }}>Page Not Found</h2>
      <p style={{ maxWidth: '400px', marginBottom: '30px' }}>
        Oops! The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          textDecoration: 'none',
          backgroundColor: '#007bff',
          color: '#fff',
          padding: '10px 20px',
          borderRadius: '5px',
          fontWeight: 'bold'
        }}
      >
        Go to Homepage
      </Link>
    </div>
  );
}
